export const CONSENTS_DOCUMENT_TYPE = 'Consent';
export const STANDING_ORDERS_DOCUMENT_TYPE = 'Standing Order';
export const CARE_MESSAGES_DOCUMENT_TYPE = 'Care Message';
export const OTHER_DOCUMENT_TYPE = 'Other';
